export default "__VITE_ASSET__BBa0vLz7__"